<template>
    
    <div class="slider">
        <img v-if="$route.params.school == 'ali-ibn-musa'" src="@/assets/madares-bg/ali-ibn-musa.jpg" alt="background">
        <img v-if="$route.params.school == 'karimeh'" src="@/assets/madares-bg/karimeh.jpg" alt="background">
        <img v-if="$route.params.school == 'sadr'" src="@/assets/madares-bg/sadr.jpg" alt="background">
        <img v-if="$route.params.school == 'imam-kazem'" src="@/assets/madares-bg/imam-kazem.jpg" alt="background">
        <img v-if="$route.params.school == 'imam-javad'" src="@/assets/madares-bg/imam-javad.jpg" alt="background">
        <img v-if="$route.params.school == 'imam-sadeq'" src="@/assets/madares-bg/imam-sadeq.jpg" alt="background">
        <img v-if="$route.params.school == 'women-qom'" src="@/assets/madares-bg/women-qom.jpg" alt="background">
        <img v-if="$route.params.school == 'women-tehran'" src="@/assets/madares-bg/women-tehran.jpg" alt="background">
        <img v-if="$route.params.school == 'markaz-tehran'" src="@/assets/madares-bg/markaz-tehran.jpg" alt="background">
        <img v-if="$route.params.school == 'markaz-qom'" src="@/assets/madares-bg/markaz-qom.jpg" alt="background">
    </div>
    <div class="diwider-tape">
        <div class="green-tape"></div>
        <div class="gray-tape"></div>
        <div class="brown-tape"></div>
    </div>

    <!-- <div class="about-mesh">
        
    </div> -->

    <div class="news-box">
        <span class="title">{{ t('schools.title', { school: schools[$route.params.school][locale] }) }}</span>
        <div class="news">
            <NewsCard v-if="lastNews.vin[0].id" type="top" :the-new="lastNews.vin[0]" :school="$route.params.school" />
            <NewsCard v-for="(thisNew, index) in lastNews.non_vin" :key="index" type="post-1"  :school="$route.params.school" :the-new="thisNew" />
            <NewsCard v-if="lastNews.vin[1].id" type="top" :the-new="lastNews.vin[1]"  :school="$route.params.school" />
        </div>
        <router-link class="more" :to="$route.params.locale ? `/${$route.params.locale}/${$route.params.school}/news` : `/${$route.params.school}/news`">{{ t('home.more') }}</router-link>
    </div>

    <div class="calendar-box">
        <div class="container">
            <div class="calendar-pic">
                <h2>{{ t('home.calendar.title') }}</h2>
                <img src="@/assets/lifestyle.png">
            </div>
            <div class="calendar-list">
                <div class="list-item">
                    <table class="myTable">
                        <tbody>
                            <tr v-for="(event, i) in (auth && auth.news.create ? [...events, newEvent] : events)" :key="i" :class="event.link ? ['clickable'] : []">
                                <td v-if="event.link && !editingEvents[i]">
                                    <a :href="event.link">
                                        <h2>{{ event.name }}</h2>
                                        <p>{{ numberToText(event.date.day) }} {{ numberToMonth(event.date.month) }} {{ numberToPersian(event.date.year) }}</p>
                                    </a>
                                    <span>
                                        <button type="button" :title="t('edit')" v-if="auth ? auth.news.edit : false" @click="editingEvents[i]++" style="float: left; color: #fff;">✎</button>
                                        <button type="button" :title="t('delete')" v-if="auth ? auth.news.delete : false" @click="onDeleteEvent(event.id)" style="float: left; color: #fff; font-size: 130%;">&times;</button>
                                    </span>
                                </td>
                                <td v-else>
                                    <span>
                                        <h2 v-if="!editingEvents[i]">{{ event.name }}</h2>
                                        <h2 v-else>
                                            <input v-if="editingEvents[i] -2" type="text" dir="rtl" :placeholder="t(i != events.length ? 'home.calendar.text' : 'home.calendar.new')" v-model="event.name">
                                            <input v-else type="url" dir="ltr" placeholder="https://" v-model="event.link">
                                        </h2>
                                        <p v-if="!editingEvents[i]">
                                            {{ numberToText(event.date.day) }} {{ numberToMonth(event.date.month) }} {{ numberToPersian(event.date.year) }}
                                        </p>
                                        <p v-else>
                                            <input type="number" dir="ltr" :placeholder="today[2]" step="1" min="1" max="31" v-model="event.date.day">
                                            /
                                            <input type="number" dir="ltr" :placeholder="today[1]" step="1" min="1" max="12" v-model="event.date.month">
                                            /
                                            <input type="number" dir="ltr" :placeholder="today[0]" step="1" min="1300" max="1500" v-model="event.date.year">
                                        </p>
                                    </span>
                                    <span v-if="!editingEvents[i]">
                                        <button type="button" :title="t('edit')" v-if="auth ? auth.news.edit : false" @click="editingEvents[i]++" style="float: left; color: #fff;">✎</button>
                                        <button type="button" :title="t('delete')" v-if="auth ? auth.news.delete : false" @click="onDeleteEvent(event.id)" style="float: left; color: #fff; font-size: 130%;">&times;</button>
                                    </span>
                                    <span v-else>
                                        <button type="button" :title="t('create')" @click="(i != events.length ? onSubmitEditEvent : onSubmitNewEvent)({ content: event.name, date: { day: event.date.day, month: event.date.month, year: event.date.year }, link: event.link }, event.id)" style="float: left; color: #fff;">&check;</button>
                                        <button type="button" :title="t('link')" @click="editingEvents[i] = !(editingEvents[i] - 1) + 1" class="link_button" style="float: left; color: #fff;"> </button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, watch } from 'vue'
import { useAuth } from '@/authentication'
import { useI18n } from 'vue-i18n'
import NewsCard from '@/components/NewsCard'
import { useRoute } from 'vue-router'

const auth = useAuth()
    , $route = useRoute()
    , { locale, t } = useI18n()
    , newsTemplate = { id: 0, main_headline: '', kicker: '', pictures: { main: null } }
    , lastNews = ref({ vin: [newsTemplate, newsTemplate], non_vin: [] })
    , events = ref([])
    , newEvent = ref({
        name: '',
        link: '',
        date: { day: '', month: '', year: '' },
        id: 0
    }),
    editingEvents = ref([]),
    today = (new Date).toLocaleDateString('fa-ir').split('/').map(n => parseInt(persianNumToNum(n)))

if ($route.params.locale) locale.value = $route.params.locale

function numberToText(num) {
    var result = ""
    if (num > 31) return false;
    if ((num - num % 10) / 10 == 0) {
        switch (num % 10) {
            case 1: result = "یکم"; break;
            case 2: result = "دوم"; break;
            case 3: result = "سوم"; break;
            case 4: result = "چهارم"; break;
            case 5: result = "پنجم"; break;
            case 6: result = "ششم"; break;
            case 7: result = "هفتم"; break;
            case 8: result = "هشتم"; break;
            case 9: result = "نهم"; break;
        }
    } else if ((num - num % 10) / 10 == 1) {
        switch (num % 10) {
            case 0: result = "دهم"; break;
            case 1: result = "یازدهم"; break;
            case 2: result = "دوازدهم"; break;
            case 3: result = "سیزدهم"; break;
            case 4: result = "چهاردهم"; break;
            case 5: result = "پانزدهم"; break;
            case 6: result = "شانزدهم"; break;
            case 7: result = "هفدهم"; break;
            case 8: result = "هجدهم"; break;
            case 9: result = "نوزدهم"; break;
        }
    } else if ((num - num % 10) / 10 == 2 || (num - num % 10) / 10 == 3) {
        result = (num - num % 10) / 10 == 2 ? "بیست" : "سی"
        switch (num % 10) {
            case 0: result += (num - num % 10) / 10 == 2 ? "م" : "‌ام"; break;
            case 1: result += " و یکم"; break;
            case 2: result += " و دوم"; break;
            case 3: result += " و سوم"; break;
            case 4: result += " و چهارم"; break;
            case 5: result += " و پنجم"; break;
            case 6: result += " و ششم"; break;
            case 7: result += " و هفتم"; break;
            case 8: result += " و هشتم"; break;
            case 9: result += " و نهم"; break;
        }
    }
    return result
}

function numberToMonth(num) {
    var result = ""
    if (num > 12) return false

    switch (num) {
        case 1: var result = "فروردین"; break;
        case 2: var result = "اردیبهشت"; break;
        case 3: var result = "خرداد"; break;
        case 4: var result = "تیر"; break;
        case 5: var result = "مرداد"; break;
        case 6: var result = "شهریور"; break;
        case 7: var result = "مهر"; break;
        case 8: var result = "آبان"; break;
        case 9: var result = "آذر"; break;
        case 10: var result = "دی"; break;
        case 11: var result = "بهمن"; break;
        case 12: var result = "اسفند"; break;
    }

    return result
}

function persianNumToNum(num) {
    return parseInt(num
        .replaceAll('۰','0')
        .replaceAll('۱','1')
        .replaceAll('۲','2')
        .replaceAll('۳','3')
        .replaceAll('۴','4')
        .replaceAll('۵','5')
        .replaceAll('۶','6')
        .replaceAll('۷','7')
        .replaceAll('۸','8')
        .replaceAll('۹','9')
    )
}

function numberToPersian(num) {
    return num.toLocaleString('fa-ir').replaceAll('٬', "")
}

function onSubmitNewEvent(values) {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}new-event`,
        method: "POST",
        dataType: "json",
        xhrFields: {
            withCredentials: true
        },
        data: { ...values, school: $route.params.school.replaceAll('-','_') },
        success(data) {
            if (data.STATUS) {
                alert('ثبت موفقیت آمیز بود')
                location.reload()
            } else {
                alert(data.REASON)
            }
        }
    })
}

function onSubmitEditEvent(values, id) {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}edit-event`,
        method: "POST",
        dataType: "json",
        xhrFields: {
            withCredentials: true
        },
        data: { ...values, id },
        success(data) {
            if (data.STATUS) {
                alert('ویرایش موفقیت آمیز بود')
                location.reload()
            } else {
                alert(data.REASON)
            }
        }
    })
}

function onDeleteEvent(id) {
    if(confirm('آیا مطمئنید می‌خواهید این رویداد را حذف کنید؟')) {
        $.ajax({
            url: `${process.env.VUE_APP_SERVER_ROOT}delete-event`,
            method: "POST",
            dataType: "json",
            xhrFields: { withCredentials: true },
            data: { id },
            success(data) {
                if (data.STATUS) {
                    alert('حذف موفقیت آمیز بود')
                    location.reload()
                } else {
                    alert(data.REASON)
                }
            }
        })
    }
}


function loadPage() {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/last-news/8-${$route.params.school.replaceAll('-','_')}`,
        method: "GET",
        dataType: "json",
        xhrFields: { withCredentials: true },
        success(data) {
            if (data.STATUS) {
                lastNews.value = { vin: [ data.VIN[0] ?? newsTemplate, data.VIN[1] ?? newsTemplate ], non_vin: data.NON_VIN }
            } else {
                alert("دریافت آخرین اخبار موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
            }
        },
        error() {
            alert('ارتباط با سرور ممکن نمی‌باشد')
        }
    })

    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/${$route.params.school.replaceAll('-', '_')}/events`,
        method: "GET",
        dataType: "json",
        xhrFields: { withCredentials: true },
        success(data) {
            if (data.STATUS) {
                let result = data.RESULT.map((event,i) => {
                    let date = event.date
                    ,   enDate = (new Date(date)).toLocaleDateString("fa-ir")
                    ,   [ year, month, day ] = enDate.split("/").map(n => parseInt(persianNumToNum(n)))

                    event.date = { year, month, day }
                    editingEvents.value[i] = 0
                    return event
                })

                editingEvents.value.push(1)
                events.value = result
            } else {
                alert("دریافت رویدادها موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
            }
        },
        error() {
            alert("ارتباط با سرور ممکن نمی‌باشد")
        }
    })
}
loadPage()
watch($route, loadPage)


const schools = {
    "ali-ibn-musa": { fa: 'مدرسهٔ علی ابن موسی الرضا (علیهماالسلام)', ar: 'مدرس علي‌بن موسی الرضا (عليهماالسلام)' },
    "karimeh": { fa: 'مدرسهٔ کریمه اهل بیت (سلام الله علیها)', ar: 'مدرس کريمة اهل‌بیت (سلام الله عليها)' },
    "sadr": { fa: 'مدرسهٔ صدر بازار', ar: 'مدرس صدر' },
    "imam-javad": { fa: 'مدرسهٔ امام جواد (علیه السلام)', ar: 'مدرس الإمام الجواد (عليه السلام)' },
    "imam-kazem": { fa: 'مدرسهٔ امام کاظم (علیه السلام)', ar: 'مدرس الإمام کاظم (عليه السلام)' },
    "imam-sadeq": { fa: 'مدرسهٔ امام صادق (علیه السلام)', ar: 'مدرس الإمام صادق (عليه السلام)' },
    "markaz-qom": { fa: 'مؤسسه آموزش عالی حوزوی - شعبه قم', ar: 'مؤسسة التعلیم العالی - في القم' },
    "markaz-tehran": { fa: 'مؤسسه آموزش عالی حوزوی - شعبه تهران', ar: 'مؤسسه التعلیم العالی - في الطهران' },
    "women-tehran": { fa: 'مدرسهٔ مشکات اندیشه خواهران تهران', ar: 'مدرس مشکاة للنساء - طهران' },
    "women-qom": { fa: 'مدرسهٔ مشکات اندیشه خواهران قم', ar: 'مدرس مشکاة للنساء - قم' }
}
</script>